import { Skeleton, theme } from "antd";
import React from "react";

import {
  ColJobDepartment,
  ColJobLocation,
  ColJobTitle,
  RowJobListing,
} from "./styled";

export const JobListingSkeleton: React.FC = () => {
  const { token } = theme.useToken();

  return (
    <RowJobListing $token={token} $skeleton={true}>
      <ColJobTitle $token={token}>
        <SkeletonComponent />
      </ColJobTitle>
      <ColJobDepartment>
        <SkeletonComponent />
      </ColJobDepartment>
      <ColJobLocation>
        <SkeletonComponent />
      </ColJobLocation>
    </RowJobListing>
  );
};

const SkeletonComponent: React.FC = () => (
  <Skeleton.Button active={true} size="small" block={true} />
);
